import type { GetApiCourses200ContentItem } from './getApiCourses200ContentItem';
import type { GetApiCourses200Pageable } from './getApiCourses200Pageable';

export type GetApiCourses200 = {
  /** 강의 목록 */
  content: GetApiCourses200ContentItem[];
  /** 빈 페이지 여부 */
  empty: boolean;
  /** 첫 번째 페이지 여부 */
  first: boolean;
  /** 마지막 페이지 여부 */
  last: boolean;
  /** 현재 페이지 번호 (0부터 시작) */
  number: number;
  /** 현재 페이지의 요소 수 */
  numberOfElements: number;
  /** Spring Data Pageable 정보 */
  pageable?: GetApiCourses200Pageable;
  /** 페이지 크기 */
  size: number;
  /** 전체 요소 수 */
  totalElements: number;
  /** 전체 페이지 수 */
  totalPages: number;
};
